import React from 'react'
import Button from './Button'


const ButtonList = () => {
    return (
        <div className='flex items-center border-b-2 md:border-none md:justify-center'>
            <Button name='All' />
            <Button name='Mixes' />
            <Button name='Programing' />
            <Button name='T-series' />
            <Button name='Mantras' />
            <Button name='Live' />
            <Button name='News' />
            <Button name='Dramedy' />
            <Button name='Indian pop music' />
            <Button name='Gaming' />
            <Button name='New songs' />





        </div>
    )
}

export default ButtonList
